import { Tooltip } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import "../Dynamic/LoginHistory.scss";
import SearchBar from "../Static/SearchBar";
import DataGridLoader from "../Common/DataGridLoader";

const LoginHistory = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const history = useHistory();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    //call the service which load all the login history details
    loadLoginHistoryDetails(page,pageSize);
  }, []);

  const loadLoginHistoryDetails = async (page, size) => {
    try {
      setIsLoading(true);
      const response = await Service.getLoginHistory(page, size).then((response) => {
        console.log(response.data);
        setTableData(response.data.content);
        setTotalCount(response.data.totalElements); 
        setIsLoading(false);
      });
    } catch (error) {
      console.log("error fetching data" + error);
      setIsLoading(false);
    }
  };

  //add tooltip
  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString()}>
        <span>{value?.toString()}</span>
      </Tooltip>
    );
  };

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerClassName: "table-header",
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "table-header",
      flex: 1,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "ipAddress",
      headerName: "IP Address",
      headerClassName: "table-header",
      flex: 1,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "userAgent",
      headerName: "User Agent",
      headerClassName: "table-header",
      flex: 1,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "address",
      headerName: "Location",
      headerClassName: "table-header",
      flex: 1,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "loginTime",
      headerName: "Login Time",
      headerClassName: "table-header",
      flex: 1,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.loginTime ? row.loginTime : null;

        //call the method which give the formatted date and time
        if (dateTimeString) return CommonService.formatDateTime(dateTimeString);
      },
    },
  ];

  // Filter rows based on search query
  const filteredRows = tableData.filter(
    (row) =>
      row.name?.toLowerCase().includes(search?.toLowerCase()) ||
      row.email?.toLowerCase().includes(search?.toLowerCase()) ||
      row.city?.toLowerCase().includes(search?.toLowerCase())
  );

  // Map filtered rows with unique IDs
  const tableDataWithIds = filteredRows.map((rowData, index) => ({
    ...rowData,
    id: index + 1, // Assigning a unique ID based on the index
  }));

  const [isLoading, setIsLoading] = useState(false);
  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };

  const handleBack = () => {
    history.goBack();
  }
  
  return (
    <div className="usersList">
      <div className="usersList__header--wrapper d-flex flex-wrap align-items-center gap-3">
        {/* <IconButton
          onClick={handleBack}
          aria-label="ArrowBackIcon"
          sx={{
            backgroundColor: "#FFF",
            mb: 1,
            "&:hover": { backgroundColor: "#FFF" },
          }}
        >
          <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
        </IconButton> */}
        <div className="header--title">
          <h1 className="title mb-0">
            Login History <i className="bi bi-heart-fill"></i>
          </h1>
        </div>
        <div className="header--menu">
          <div className="header--menu-items row d-flex justify-content-end">
            <div className="col-auto">
              <SearchBar search={search} setSearch={setSearch} />
            </div>
            {/* <div className="col-auto menu-items__btnGroup btnGroup-border d-inline-flex mb-2"></div> */}
          </div>
        </div>
      </div>
      <div className="user-table-container">
        <div className="userTable">

        <DataGrid
            localeText={localeText}
            disableRowSelectionOnClick={true}
            rows={tableDataWithIds}
            columns={columns}
            className="data-grid"
            initialState={{
              pagination: {
                paginationModel: { page: page, pageSize: pageSize },
              },
            }}
            pagination
            paginationModel={{
              page,
              pageSize,
            }}
            onPaginationModelChange={(newPaginationModel) => {
              setPage(newPaginationModel.page);
              setPageSize(newPaginationModel.pageSize);

              loadLoginHistoryDetails(newPaginationModel.page, newPaginationModel.pageSize);
            }}
            rowCount={totalCount}
            paginationMode="server"
            pageSizeOptions={[10, 20, 50, 100]}
            loading={isLoading}
            slots={{
              loadingOverlay: DataGridLoader,
            }}
            // checkboxSelection
            // getRowClassName={getCellClassName}
          />

          
        </div>
      </div>
    </div>
  );
};

export default LoginHistory;
